import React, { useCallback, useEffect, useState } from 'react';
import {
    Button,
    FlexDirectionRow,
    FormRowFlex,
    MainContent,
    RadioOptionFilter,
    SubTitle,
} from '../../../../../components/StyledComponents';
import './styles.module.scss';
import { IncluirRegrasModel } from './incluirRegras.model.js';
import Input from '../../../../../components/InputControlled';
import { useFieldArray, useForm } from 'react-hook-form';
import { minValue, valueIsRequired } from '../../../../../utils/regex';
import Select from '../../../../../components/Select';
import { handleModalStatus } from '../../../../../utils/handleModalStatus';
import { RegrasContabilizacaoService } from '../../../services/regrasContabilizacaoService';
import RadioOrCheckboxGroup from '../../../../../components/RadioOrCheckboxGroup';
import { BaSeDialogContext, BaSeIcon } from '@base/react';
import ChipsGroup from '../../../../../components/ChipsGroup';
import { useApp } from '../../../../../context/app';
import { formatInstrumentString, onlyInputNumbers, parseStringToJson, } from '../../../../../utils/utils';
import { UserActionsContent } from '../../../../../components/UserActionsContent';
import styles from './styles.module.scss';
import { Box, CircularProgress, Grid, Stack } from '@mui/material';
import { BsPlusCircle } from 'react-icons/bs';
import { ImCancelCircle } from 'react-icons/im';
import Tooltip from '@mui/material/Tooltip';
import Chip from '../../../../../components/Chip';

export const IncluirRegrasContabilizacao = () => {
    const {setRenderIncludeScreen, manageItem} = useApp();

    const [isSubmiting, setIsSubmiting] = useState(false);

    const {showModal} = React.useContext(BaSeDialogContext);

    const {options, projetos, getTemas, temas} = IncluirRegrasModel();

    const arrayValues = [
        {
            placeholder: 'Padrão',
            value: 'TODOS',
        },
        {
            placeholder: 'MEI',
            value: 'MEI',
        },
        {
            placeholder: 'ME',
            value: 'ME',
        },
        {
            placeholder: 'EPP',
            value: 'EPP',
        },
    ];

    const {control, handleSubmit, watch, reset, getValues, setValue} = useForm({
        defaultValues: {
            nome: '',
            tipo: '',
            descricao: '',
            uf: '',
            perfil: '',
            instrumento: '',
            abordagem: '',
            temaMacro: '',
            duracao: '',
            unidadeMedida: '',
            periodos: [
                {
                    duracao: '',
                    unidadeMedida: '',
                    porte: 'TODOS',
                },
            ],
            diagnosticos: [
                {
                    diagnostico: {
                        id: null,
                        titulo: '',
                    },
                    porte: 'TODOS',
                },
            ],
            projetos: '',
            limiteDias: null,
            habilitarSegundaVisita: false,
            usaDiagnostico: 'no'
        },
    });

    const {append: appendAcoes} = useFieldArray({
        control,
        name: 'acoes',
        rules: {
            validate: valueIsRequired,
        },
    });

    const {
        fields: temasSelecionados,
        append: appendSubTema,
        remove: removeSubTema,
    } = useFieldArray({
        control,
        name: 'temas',
        rules: {
            validate: valueIsRequired,
        },
    });

    const {
        fields,
        append: appendPeriodo,
        remove: removePeriodo,
    } = useFieldArray({
        control,
        name: 'periodos',
        rules: {
            validate: valueIsRequired,
        },
    });

    const {
        fields: diagnosticosSelecionados,
        append: appendDiagnosticos,
        remove: removeDiagnosticos,
        replace: replaceDiagnosticos,
    } = useFieldArray({
        control,
        name: 'diagnosticos',
        rules: {
            validate: valueIsRequired,
        },
    });

    const usaDiagnostico = watch('usaDiagnostico');
    const diagnosticosSelecionadosWatch = watch('diagnosticos');
    const temaMacro = watch('temaMacro');
    const acoesForm = watch('acoes');

    useEffect(() => {
        if (manageItem?.data && projetos.length) {
            console.log('manageItem', manageItem)
            console.log('diagnosticosSelecionados', diagnosticosSelecionados)
            console.log('diagnosticosSelecionadosWatch', diagnosticosSelecionadosWatch)


            // Define o projeto selecionado
            manageItem.data.projetos = projetos.filter(
                (item) => item.id === manageItem.data?.projetos[0]?.id
            )[0];

            // Reseta o formulário com os dados do registro
            reset(manageItem.data);

            // Adiciona o subtema se estiver presente no registro
            if (manageItem.data.tema && !manageItem.data.temas) {
                appendSubTema(manageItem.data.tema);
            }
            setValue('usaDiagnostico', manageItem.data?.diagnosticos?.length ? 'yes' : 'no')

            if (manageItem.data?.diagnosticos?.length) {
                replaceDiagnosticos(manageItem.data.diagnosticos);
            } else {
                replaceDiagnosticos([
                    {
                        diagnostico: {
                            id: null,
                            titulo: '',
                        },
                        porte: 'TODOS',
                    },
                ])
            }
        }
        // eslint-disable-next-line
    }, [manageItem, projetos, reset]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (temaMacro) {
            const temaMacroId =
                typeof temaMacro === 'string' ? JSON.parse(temaMacro).id : temaMacro.id;
            getTemas(temaMacroId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [temaMacro]);

    const handleGoHome = () => {
        setRenderIncludeScreen(false);
    };

    const setAcoes = useCallback(
        (data) => {
            const dataAcoes = parseStringToJson(data).acoes;
            const inArray = acoesForm?.some((p) =>
                dataAcoes.find((c) => c.id === p.id)
            );
            if (!inArray) {
                appendAcoes(dataAcoes);
            }
        },
        [appendAcoes, acoesForm]
    );

    const handleSelectSubtema = (data) => {
        if (!data) return;
        const subtema = parseStringToJson(data);
        const isSelected = temasSelecionados?.some(
            (tema) => tema.codigoSiac === subtema.codigoSiac
        );
        if (!isSelected) {
            appendSubTema(subtema);
        }
    };

    const handleNomeAcao = (acao) => {
        const projeto = projetos?.find((p) => p?.codigoProjeto === acao?.codPratif);
        return projeto?.nuPratif
            ? `${projeto.nuPratif} - ${projeto.nomePratif} - ${acao.nomeAcao}`
            : acao.nomeAcao;
    };

    const handleRemoveSubtema = (index) => {
        removeSubTema(index);
    };

    const handleRemoveDiagnostico = (index) => {
        const diagnosticos = watch('diagnosticos');
        if (diagnosticos.length > 1) {
            removeDiagnosticos(index)
        }
    }

    const handleAppendDiagnostico = () => {
        const diagnosticos = watch('diagnosticos');
        if (diagnosticos.length < 4) {
            appendDiagnosticos({
                diagnostico: '',
                porte: '',
            });
        }
    }

    const submitForm = async (dataForm) => {
        // eslint-disable-next-line
        if (dataForm.usaDiagnostico === 'no') {
            delete dataForm.diagnosticos;
            delete dataForm.diagnostico;
        } else {
            dataForm.diagnostico = parseStringToJson(dataForm.diagnostico);
        }

        dataForm.perfil = parseStringToJson(dataForm.perfil);
        dataForm.uf = parseStringToJson(dataForm.uf);
        dataForm.tipo = parseStringToJson(dataForm.tipo);
        dataForm.temaMacro = parseStringToJson(dataForm.temaMacro);
        delete dataForm.tema;
        dataForm.projetos = new Array(parseStringToJson(dataForm.projetos));
        delete dataForm.projetos.acoes;
        dataForm.acoes = dataForm.acoes.filter((i) => !i.disabled);
        dataForm.limiteDias = Number(dataForm.limiteDias);

        console.log('dataForm', dataForm);
        if (dataForm.id) {
            editItem(dataForm);
        } else {
            createItem(dataForm);
        }
    };

    const createItem = async (dataForm) => {
        setIsSubmiting(true);
        await RegrasContabilizacaoService.save(dataForm)
            .then((res) => {
                if (res.data) {
                    handleModalStatus({
                        type: 'success',
                        msgOnSuccess: 'Regra de contabilização foi incluída com sucesso.',
                        onCloseModal: handleGoHome,
                        showModal,
                    });
                    setIsSubmiting(false);
                } else {
                    setIsSubmiting(false);
                    handleModalStatus({
                        type: 'error',
                        msgOnError:
                            'A regra de contabilização não foi incluído. Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.',
                        showModal,
                    });
                }
            })
            .catch(() => {
                setIsSubmiting(false);
                handleModalStatus({
                    type: 'error',
                    msgOnError:
                        'A regra de contabilização não foi incluído. Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.',
                    showModal,
                });
            });
    };

    const editItem = async (dataForm) => {
        setIsSubmiting(true);
        await RegrasContabilizacaoService.update(dataForm)
            .then((res) => {
                if (res.data) {
                    handleModalStatus({
                        type: 'success',
                        msgOnSuccess: 'Regra de contabilização foi editada com sucesso.',
                        onCloseModal: handleGoHome,
                        showModal,
                    });
                    setIsSubmiting(false);
                } else {
                    setIsSubmiting(false);
                    setIsSubmiting(false);
                    handleModalStatus({
                        type: 'error',
                        msgOnError:
                            'A regra de contabilização não foi editada. Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.',
                        showModal,
                    });
                }
            })
            .catch(() => {
                setIsSubmiting(false);
                handleModalStatus({
                    type: 'error',
                    msgOnError:
                        'A regra de contabilização não foi incluído. Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.',
                    showModal,
                });
            });
    };

    const FormPeriodo = ({index, checkedValues, isLastItem}) => {
        const arrayValues = [
            {
                placeholder: 'MEI',
                value: 'MEI',
            },
            {
                placeholder: 'ME',
                value: 'ME',
            },
            {
                placeholder: 'EPP',
                value: 'EPP',
            },
            {
                placeholder: 'Padrão',
                value: 'TODOS',
            },
        ];

        return (
            <Stack direction="row" gap="0.5rem">
                <Input
                    {...{onKeyPress: onlyInputNumbers}}
                    name={`periodos.${index}.duracao`}
                    type="number"
                    rules={{
                        ...valueIsRequired(),
                        ...minValue(1),
                    }}
                    control={control}
                    placeholder="Duração"
                />
                <Select
                    name={`periodos.${index}.unidadeMedida`}
                    placeholder="Un. Medida"
                    options={options?.unidades}
                    control={control}
                    rules={{...valueIsRequired()}}
                />

                <Stack
                    direction="row"
                    gap="1rem"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Box mt="0.5rem">
                        <RadioOrCheckboxGroup
                            notRequired={true}
                            name={`periodos.${index}.porte`}
                            control={control}
                            rules={{...valueIsRequired()}}
                            values={arrayValues.filter(
                                (item) => !checkedValues.find((i) => i === item.value)
                            )}
                            fontSize="0.7rem"
                            marginTop="0.2rem"
                            columnGap="7px"
                            marginRight="5px"
                        />
                    </Box>

                    <Box display="flex" flexDirection="row" gap="0.5rem">
                        <Tooltip title="Delete">
                            <div>
                                <ImCancelCircle
                                    size={20}
                                    color="#F4455A"
                                    onClick={() => {
                                        removePeriodo(index);
                                    }}
                                />
                            </div>
                        </Tooltip>
                        <Tooltip title="Adicionar">
                            <div>
                                <button
                                    className={styles.actionsButtonAdd}
                                    style={{
                                        cursor: 'pointer',
                                        display:
                                            !isLastItem ||
                                            arrayValues.filter(
                                                (item) => !checkedValues.find((i) => i === item.value)
                                            ).length <= 1
                                                ? 'none'
                                                : '',
                                    }}
                                    onClick={() => {
                                        appendPeriodo({
                                            duracao: '',
                                            unidadeMedida: '',
                                            porte: '',
                                        });
                                    }}
                                >
                                    <BsPlusCircle size={20} color="#0061C6"/>
                                </button>
                            </div>
                        </Tooltip>
                    </Box>
                </Stack>
            </Stack>
        );
    };

    const FormPeriodoTodos = ({index, checkedValues}) => {
        const arrayValues = [
            {
                placeholder: 'Padrão',
                value: 'TODOS',
            },
        ];

        return (
            <Stack direction="row" gap="0.5rem">
                <Input
                    {...{onKeyPress: onlyInputNumbers}}
                    name={`periodos.${index}.duracao`}
                    type="number"
                    rules={{
                        ...valueIsRequired(),
                        ...minValue(1),
                    }}
                    control={control}
                    placeholder="Duração"
                />
                <Select
                    name={`periodos.${index}.unidadeMedida`}
                    placeholder="Un. Medida"
                    options={options?.unidades}
                    control={control}
                    rules={{...valueIsRequired()}}
                />

                <Stack
                    direction="row"
                    gap="1rem"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Box mt="0.5rem">
                        <RadioOrCheckboxGroup
                            notRequired={true}
                            name={`periodos.${index}.porte`}
                            control={control}
                            rules={{...valueIsRequired()}}
                            values={arrayValues.filter(
                                (item) => !checkedValues.find((i) => i === item.value)
                            )}
                            fontSize="0.8rem"
                            marginTop="0.2rem"
                        />
                    </Box>
                    <Box>
                        <Tooltip title="Adicionar">
                            <div>
                                <button
                                    className={styles.actionsButtonAdd}
                                    style={{
                                        display: fields.length > 1 ? 'none' : '',
                                    }}
                                    onClick={() => {
                                        appendPeriodo({
                                            duracao: '',
                                            unidadeMedida: '',
                                            porte: '',
                                        });
                                    }}
                                >
                                    <BsPlusCircle size={20} color="#0061C6"/>
                                </button>
                            </div>
                        </Tooltip>
                    </Box>
                </Stack>
            </Stack>
        );
    };

    const FormDiagnosticos = ({index, isLastItem, arrayValues}) => {

        return (
            <Stack direction="row" gap="0.5rem">
                <Select
                    name={`diagnosticos.${index}.diagnostico`}
                    defaultName="titulo"
                    returnItem
                    returnAsObject
                    placeholder={null}
                    options={options?.diagnosticos}
                    control={control}
                    rules={{...valueIsRequired()}}
                />

                <Stack
                    direction="row"
                    gap="1rem"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Box mt="0.5rem">
                        <RadioOrCheckboxGroup
                            notRequired={true}
                            name={`diagnosticos.${index}.porte`}
                            control={control}
                            rules={{...valueIsRequired()}}
                            values={arrayValues}
                            fontSize="0.7rem"
                            marginTop="0.2rem"
                            columnGap="7px"
                            marginRight="5px"
                        />
                    </Box>

                    <Box display="flex" flexDirection="row" gap="0.5rem">
                        <Tooltip title="Delete">
                            <div>
                                <ImCancelCircle
                                    size={20}
                                    color="#F4455A"
                                    onClick={() => {
                                        handleRemoveDiagnostico(index);
                                    }}
                                />
                            </div>
                        </Tooltip>
                        <Tooltip title="Adicionar">
                            <div>
                                <button
                                    className={styles.actionsButtonAdd}
                                    style={{
                                        cursor: 'pointer',
                                        display:
                                            !isLastItem ? 'none' : '',
                                    }}
                                    onClick={() => {
                                        handleAppendDiagnostico()
                                    }}
                                >
                                    <BsPlusCircle size={20} color="#0061C6"/>
                                </button>
                            </div>
                        </Tooltip>
                    </Box>
                </Stack>
            </Stack>
        );
    };

    return (
        <>
            <MainContent>
                <SubTitle>
                    <h3>{manageItem?.data?.id ? 'Editar' : 'Incluir'}</h3>
                </SubTitle>

                <Grid container spacing={2}>
                    <Grid item md={6}>
                        <Input
                            name="nome"
                            control={control}
                            maxLength={255}
                            rules={{...valueIsRequired()}}
                            placeholder="Nome da regra"
                        />
                        <Select
                            name="tipo"
                            placeholder="Tipo de realização do registro"
                            options={options?.tipos}
                            returnItem
                            control={control}
                            rules={{...valueIsRequired()}}
                        />
                        <Input
                            name="descricao"
                            control={control}
                            maxLength={2000}
                            rules={{...valueIsRequired()}}
                            placeholder="Descrição da realização do registro"
                        />
                        <FormRowFlex>
                            <Select
                                name="uf"
                                returnItem
                                defaultName="sigla"
                                placeholder="UF"
                                options={options?.ufs}
                                control={control}
                                rules={{...valueIsRequired()}}
                            />
                            <Select
                                width={'100%'}
                                name="perfil"
                                returnItem
                                capitalize={true}
                                placeholder="Perfil do usuário"
                                options={options?.perfis}
                                control={control}
                                rules={{...valueIsRequired()}}
                            />
                        </FormRowFlex>
                        <Stack direction="row" spacing={2}>
                            <RadioOrCheckboxGroup
                                title="Público-alvo"
                                name="publicos"
                                radio={false}
                                returnItem
                                control={control}
                                rules={{...valueIsRequired()}}
                                values={options?.publicos}
                                defaultName="nome"
                                defaultValueProp="id"
                                columnGap="0.8rem"
                                marginRight="5px"
                            />
                            <Stack direction="row" spacing={1}>
                                <RadioOrCheckboxGroup
                                    title="2ª Visita"
                                    name="habilitarSegundaVisita"
                                    control={control}
                                    values={[
                                        {
                                            placeholder: 'Não',
                                            value: false,
                                        },
                                        {
                                            placeholder: 'Sim',
                                            value: true,
                                        },
                                    ]}
                                    columnGap="0.8rem"
                                    marginRight="5px"
                                />
                                <Stack direction="row" spacing={3.5} alignItems="center">
                                    <Input
                                        name="limiteDias"
                                        type="number"
                                        required={false}
                                        control={control}
                                        maxLength={2}
                                        showMaxLengthLabel={false}
                                        label="Limite dia"
                                        fontSizeLabel="12px"
                                        width="3.8rem"
                                        min="1"
                                    />
                                    <RadioOptionFilter
                                        margin-right=""
                                        fontSize="10px"
                                        lineHeight="12px"
                                    >
                                        unidades
                                    </RadioOptionFilter>
                                </Stack>
                            </Stack>
                        </Stack>
                        <Select
                            name="instrumento"
                            placeholder="Instrumento"
                            options={options?.instrumentos}
                            formatOptionLabel={formatInstrumentString}
                            control={control}
                            rules={{...valueIsRequired()}}
                        />
                        <Select
                            name="abordagem"
                            placeholder="Abordagem"
                            options={options?.abordagens}
                            control={control}
                            rules={{...valueIsRequired()}}
                        />
                        <Select
                            name="temaMacro"
                            defaultName="descricao"
                            returnItem
                            placeholder="Tema"
                            options={options?.temasMacro}
                            control={control}
                            rules={{...valueIsRequired()}}
                        />
                        {temas?.length ? (
                            <>
                                <Grid
                                    container
                                    direction="row"
                                    display={'flex'}
                                    alignItems={'center'}
                                    justifyContent={'space-between'}
                                >
                                    <Grid item width={'93.4%'}>
                                        <Select
                                            name="tema"
                                            defaultName="descricao"
                                            returnItem
                                            placeholder="Subtema"
                                            options={temas}
                                            control={control}
                                            rules={{...valueIsRequired()}}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        width={'5%'}
                                        display={'flex'}
                                        justifyContent={'end'}
                                    >
                                        <div>
                                            <BaSeIcon
                                                style={{
                                                    display: 'flex',
                                                    alignSelf: 'center',
                                                }}
                                                onClick={() => {
                                                    const subtemaSelecionado = getValues('tema');
                                                    handleSelectSubtema(subtemaSelecionado);
                                                }}
                                                name="plus-circle"
                                                description="Adicionar Subtemas"
                                                color="#0061C6"
                                                size={35}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                                <Grid item>
                                    {temasSelecionados?.map((item, index) => {
                                        return (
                                            <Chip
                                                fontSize={'12px'}
                                                key={index.toString()}
                                                id={item.id}
                                                placeholder={item?.descricao}
                                                onChange={() => handleRemoveSubtema(index)}
                                            />
                                        );
                                    })}
                                </Grid>
                            </>
                        ) : (
                            <></>
                        )}
                        {fields.map((item, index) => {
                            return (
                                <div key={item.id}>
                                    {item.porte === 'TODOS' ? (
                                        <FormPeriodoTodos
                                            index={index}
                                            checkedValues={fields
                                                .filter((i) => i.id !== item.id)
                                                .map((i) => i.porte)}
                                            item={item}
                                            isLastItem={index === fields.length - 1}
                                        />
                                    ) : (
                                        <FormPeriodo
                                            index={index}
                                            checkedValues={fields
                                                .filter((i) => i.id !== item.id)
                                                .map((i) => i.porte)}
                                            item={item}
                                            isLastItem={index === fields.length - 1}
                                        />
                                    )}
                                </div>
                            );
                        })}
                        <RadioOrCheckboxGroup
                            title="Vai usar um diagnóstico?"
                            name="usaDiagnostico"
                            control={control}
                            rules={{...valueIsRequired()}}
                            values={[
                                {
                                    placeholder: 'Sim',
                                    value: 'yes',
                                },
                                {
                                    placeholder: 'Não',
                                    value: 'no',
                                },
                            ]}
                        />

                        {
                            (usaDiagnostico === 'yes') ?
                                <div>
                                    <p>Qual diagnóstico?</p>
                                    {
                                        diagnosticosSelecionados.map((item, index) => {
                                            const previousItem = getValues(`diagnosticos.${index - 1}`);
                                            const selectedValues = diagnosticosSelecionados.filter((i) => i.id !== item.id).map((i) => i.porte)
                                            const isSelectedPreviously = selectedValues.includes(previousItem?.porte);
                                            const availableOptions = index === 0
                                                ? arrayValues.filter(option => option.value === 'TODOS')
                                                : arrayValues.filter(
                                                    (option) => !isSelectedPreviously || !selectedValues.includes(option.value)
                                                );
                                            return (
                                                <div key={item.id}>
                                                    <FormDiagnosticos
                                                        checkedValues={[]}
                                                        arrayValues={availableOptions}
                                                        index={index}
                                                        item={item}
                                                        isLastItem={index === fields.length - 1}
                                                    />
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                                : null
                        }
                    </Grid>

                    <Grid item md={6}>
                        <Grid
                            container
                            direction="column"
                            justifyContent="space-between"
                            alignItems="baseline"
                        >
                            <Grid
                                item
                                md
                                container
                                direction="row"
                                justifyContent="space-between"
                                alignItems={'center'}
                            >
                                <Grid item md={10.5}>
                                    <Select
                                        name="projetos"
                                        defaultName="nomePratif"
                                        placeholder="Projeto"
                                        returnItem
                                        options={projetos}
                                        control={control}
                                        rules={{...valueIsRequired()}}
                                    />
                                </Grid>
                                <Grid item md={1}>
                                    <div>
                                        <BaSeIcon
                                            style={{
                                                display: 'flex',
                                                alignSelf: 'center',
                                            }}
                                            onClick={() => {
                                                const p = watch('projetos');
                                                if (p) setAcoes(p);
                                            }}
                                            name="plus-circle"
                                            description="Adicionar diagnóstico"
                                            color="#0061C6"
                                            size={42}
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid item>
                                <ChipsGroup
                                    handlePlaceholder={handleNomeAcao}
                                    name="acoes"
                                    {...{control, watch}}
                                />
                            </Grid>
                        </Grid>
                        <Grid item>
                            <FlexDirectionRow
                                position={'end'}
                                style={{marginRight: '40px'}}
                            >
                                <FlexDirectionRow position={'space-between'}>
                                    {manageItem?.data?.id && (
                                        <Button
                                            backgroundColor={'#9CA2A8'}
                                            type="button"
                                            onClick={() => reset()}
                                        >
                                            Limpar
                                        </Button>
                                    )}
                                    <div style={{marginLeft: '10px', marginRight: '10px'}}/>
                                    <Button
                                        href="#"
                                        onClick={handleSubmit(submitForm)}
                                        disabled={isSubmiting}
                                    >
                                        {isSubmiting ? (
                                            <CircularProgress size={20} color="info"/>
                                        ) : manageItem?.data?.id ? (
                                            'Editar regra'
                                        ) : (
                                            'Incluir regra'
                                        )}
                                    </Button>
                                </FlexDirectionRow>
                            </FlexDirectionRow>
                        </Grid>
                    </Grid>
                </Grid>
            </MainContent>
            {manageItem?.data?.id && <UserActionsContent data={manageItem?.data}/>}
        </>
    );
};
